import { useState, useEffect } from 'react'

export const useFetchAllEvents = ({marvarApi, dispatch, onLogout, Forms, Helpers}) => {
    
    const {
        getCurrentDate,
        getPreviousMonthDate,
        getNextMonthDate
    } = Helpers

    const fecha_actual = getCurrentDate()
    const fecha_inicio = getPreviousMonthDate(fecha_actual)
    const fecha_final = getNextMonthDate(fecha_actual)

    const _defaultParams = {
        fecha_actual: fecha_actual,
        fecha_inicio: fecha_inicio,
        fecha_final: fecha_final
    }
    
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)
    const [ dataEvents, setDataEvents ] = useState([])
    const [ loadingFetchEvents, setLoadingFetchEvents ] = useState(false)
    
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const _body = {
                fecha_actual: paramsToSearch.fecha_actual,
                fecha_inicio: paramsToSearch.fecha_inicio,
                fecha_final: paramsToSearch.fecha_final
            }
            const response = await marvarApi.post(`/agenda-abogacia/fetch-all-agenda-abogacia`, _body)
            // console.log('[useFetchData][useFetchAllEvents] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(
            paramsToSearch.fecha_actual !== ''
            && paramsToSearch.fecha_inicio !== ''
            && paramsToSearch.fecha_final !== ''
        ){
            setLoadingFetchEvents(true)
            fetchData()
                .then((resp) => {
                    const dataClean = resp.rows.map((item) => ({
                        id: item.idagenda,
                        title: item.tipo_evento,
                        date: item.fecha_evento,
                        backgroundColor: item.event_background
                    }))
                    // console.log('dataClean ::: ', dataClean)
                    setDataEvents(dataClean)
                    setLoadingFetchEvents(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setDataEvents([])
                    setLoadingFetchEvents(false)
                })
        }
    }, [execute])

    return { dataEvents, loadingFetchEvents, executeFetch, setParamsToSearch }

}

export const useFetchInfoEvent = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchEvent, setLoadingFetchEvent ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idagenda: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/agenda-abogacia/fetch-specific-agenda-abogacia/${paramsToSearch.idagenda}`)
            console.log('[useFetchData][useFetchInfoEvent] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idagenda > 0 ){
            setLoadingFetchEvent(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idagenda: rows[0].idagenda || '',
                        origen: rows[0].origen || '',
                        tipo_evento: rows[0].tipo_evento || '',
                        datos_cliente: rows[0].datos_cliente || '',
                        fecha_evento: rows[0].fecha_evento || '',
                        descripcion: rows[0].descripcion || ''
                    }))
                    setLoadingFetchEvent(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchEvent(false)
                })
        }
    }, [execute])

    return { loadingFetchEvent, setParamsToSearch, executeFetch }

}

export const useFetchInfoEven1 = ({marvarApi, dispatch, onLogout, Forms, Helpers}) => {

    
    const {FormRequestGlobal:{formState}, FormRequestModal:{setFormState}} = Forms
    

    const {getCurrentDate} = Helpers

    const _defaultParams = {
        idagenda: 'fecha_actual',
        fecha_actual: 'fecha_inicio',
    }

    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)
    const [ dataEvents, setDataEvents ] = useState([])
    const [ loadingFetchEvents, setLoadingFetchEvents ] = useState(false)
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoEvents = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                idagenda: formState.idagenda,
                fecha_actual: getCurrentDate()
            }
            const response = await marvarApi.post(`/agenda/info-event`, _body)
            console.log('[useFetchData][useFetchInfoEvent] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idagenda > 0){
            fetchData()
                .then((resp) => {
                    const event = resp.data[0]
                    setFormState(prevState => ({
                        ...prevState,
                        tipo_evento: event.tipo_evento,
                        color: event.color, 
                        fecha_evento: event.fecha_pago,
                        fecha_ren_seguro: event.fecha_ren_seguro, 
                        fecha_ren_gps: event.fecha_ren_gps, 
                        seguro: event.seguro, 
                        gps: event.gps, 
                        identificador: event.identificador,
                        cliente: event.cliente,
                        dias_atrasado: event.dias_atraso_totales,
                        telefono: event.telefono,
                        correo: event.correo,
                        direccion: event.direccion,
                        dpi: event.dpi,    
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return {  executeFetchInfoEvents }

}







